import React from 'react'
import { About } from '../Components/About';
import { HeroSlider } from '../Components/HeroSlider';
import { Features } from '../Components/Features';
import { StudentArea } from '../Components/StudentArea';
import { News } from '../Components/News';
import { Counter } from '../Components/Counter';
import { Publication } from '../Components/Publication';
import { Brand } from '../Components/Brand';
;
const Home = () => {

    return (
        <>
            <HeroSlider />
            <About />
            <Features />
            <StudentArea/>
            <News/>
            <Counter/>
            <Publication/>
            <Brand/>
        
        </>

    )
}

export default Home;